let locales = {
    "httpLog_user": "Usuario",
    "httpLog_date": "Fecha y hora",
    "httpLog_originLink": "Enlace de origen",
    "httpLog_destinyLink": "Enlace de destino",
    "httpLog_ip": "Dirección IP"
};


export default locales;